"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnergyDrinkStencil = exports.energyDrinkStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.energyDrinkStencilDefinition = {
    view: {
        label: 'Energy Drink',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'key-visual',
                    'local-brand-name',
                    'title',
                    'teaser',
                    'legal-disclaimer',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'url',
                            'featured-media',
                            'branding-hex-color-code',
                            'flavour',
                            'variant',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'standalone',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: { hasFeatureCardPreview: true },
    },
    content: {
        'branding-hex-color-code': properties_1.brandingHexColorCodePropertyDefinition,
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        'content-classification-terms': properties_1.contentClassificationTermsPropertyDefinition,
        'cta-container': {
            ...properties_1.ctaContainerPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: ['cta-url'],
                },
            ],
        },
        disciplines: properties_1.disciplinesPropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        flavour: properties_1.flavourPropertyDefinition,
        'key-visual': properties_1.keyVisualPropertyDefinition,
        'legal-disclaimer': properties_1.legalDisclaimerPropertyDefinition,
        'local-brand-name': properties_1.localBrandNamePropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        teaser: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 200,
                },
            ],
        },
        title: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 45,
                },
            ],
            view: {
                label: 'Edition name',
                style: 'h1',
            },
        },
        url: {
            ...properties_1.urlPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'pattern',
                    argument: '^https?:\\/\\/(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#]\\S*)?$',
                },
            ],
        },
        variant: properties_1.variantPropertyDefinition,
    },
    localizations: [],
    roles: ['taxonomy-manager'],
    spaces: ['redbull_com'],
    name: 'energy-drink',
};
const isEnergyDrinkStencil = (stencil) => {
    return stencil.name === exports.energyDrinkStencilDefinition.name;
};
exports.isEnergyDrinkStencil = isEnergyDrinkStencil;
//# sourceMappingURL=data:application/json;base64,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